// src/pages/AuthSuccess.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

export default function AuthSuccess() {
    const navigate = useNavigate();
    const [status, setStatus] = useState("Finalizing login…");

    useEffect(() => {
        const run = async () => {
        try {
            const params = new URLSearchParams(window.location.search);
            const token = params.get("token");
            if (!token) {
            setStatus("Missing token. Redirecting to login…");
            setTimeout(() => navigate("/login"), 1200);
            return;
            }

            // Échange le bridge token contre un cookie httpOnly côté backend
            const res = await API.post("/auth/bridge", { token }, { validateStatus: () => true });
            if (!res.data?.success) {
            setStatus("Login failed. Redirecting to login…");
            setTimeout(() => navigate("/login"), 1200);
            return;
            }

            // Nettoie l'URL (enlève ?token=...) puis va au dashboard
            window.history.replaceState({}, "", "/dashboard");
            navigate("/dashboard");
        } catch (e) {
            console.error(e);
            setStatus("Unexpected error. Redirecting to login…");
            setTimeout(() => navigate("/login"), 1200);
        }
        };
        run();
    }, [navigate]);

    return (
        <div className="min-h-screen grid place-items-center bg-[#0D1117] text-[#E6EDF3]">
        <div className="bg-[#161B22] border border-[#21262D] rounded-2xl p-8 text-center">
            <p className="text-lg">{status}</p>
        </div>
        </div>
    );
}
